/**
 * Web component: Lab files (lab-files)
 * -----------------------------------------------------------------------------
 * A section that pulls lab files from a metaobject called "Lab Files".
 * - Component settings: section / limited / web / vanilla
 *
 */
import './lab-files.scss';

import { vueReady } from '~/core/runners';

/**
 * Create new <lab-files> custom element.
 */
class LabFiles extends HTMLElement {
  data() {
    return {
      button: this.querySelector('.lab-files__show-more'),
      files: this.querySelectorAll('.lab-files__item'),
    };
  }

  constructor() {
    super();
    this.$data = this.data(this);
  }

  connectedCallback() {
    this.$data.button?.addEventListener('click', this.showMore.bind(this));
  }

  showMore() {
    this.$data.files.forEach((file, index) => {
      if (file.classList.contains('is-hidden')) {
        file.classList.remove('is-hidden');
        return;
      }

      if (index > 2) {
        file.classList.add('is-hidden');
      }
    });
  }
}

/**
 * Define web component on Vue initialisation.
 */
vueReady(() => {
  if (customElements.get('lab-files')) {
    return;
  }

  customElements.define('lab-files', LabFiles);
});
